import { Atom } from 'AppReact';
import styled, { css } from 'styled-components';

const template = styled.span`
  ${({ theme }) => css`
    margin-right: 8px;
    svg {
      width: 28px;
      height: 28px;
      fill: ${theme?.colour?.secondary ?? '#04333B'};
    }
  `}
`;

export default Atom({ type: 'label', dataType: 'object', template })